export enum StartPointCommandesClientsEnum {
  PLC = 'PLC',
  REPAS = 'REPAS',
  PRESTATION = 'PRESTATION'
}
